<script lang="js" setup>
import { defineProps } from 'vue'

defineProps({
  to: {
    type: String,
    required: true
  }
})

const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId)
  if (element) {
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - 50

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }
}
</script>

<template>
  <button
    @click="scrollToSection(to)"
    class="text-white text-xl font-medium relative after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-300 hover:after:w-full hover:opacity-100 focus:after:w-full focus:opacity-100 focus:outline-none opacity-50"
  >
    <slot />
  </button>
</template>

<style scoped></style>
